import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import {
    scheduleAction,
    scheduleUserAction,
} from "src/store/Slices/Administrator/ScheduleSlice";
import AddEditScheduleModal from "./Modals/AddEditScheduleModal";
import SecondTable from "./SecondTable/SecondTable";
import { values } from "lodash";
import { Image, message } from "antd";
import CopyScheduleModal from "./Modals/CopyScheduleModal";
import fallback from "./fallback.png";
import { copyToClipboard } from "src/components/helpers/copyToClipboard";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Schedule = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "updateBtn"
            ),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "deleteBtn"
            ),
        },
        {
            key: "3",
            label: "Получить ссылку на изображение",
            onClick: () => {
                copyToClipboard(scheduleInfo?.imageUrl?.props?.src);
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "updateBtn"
            ),
        },
        {
            key: "4",
            label: "Копировать",
            onClick: () => {
                setIsCopyModal(true);
            },
            disabled: !mnemo?.children[0]?.children?.find(
                (el) => el.mnemo === "updateBtn"
            ),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Расписание" },
        {
            label: "По наименованию",
            value: 2,
            index: "name",
            title: "Наименование",
        },
        { label: "По дате", value: 3, index: "date", title: "Дата" },
        { label: "По времени", value: 4, index: "time", title: "Время" },
        {
            label: "По длительности",
            value: 5,
            index: "duration",
            title: "Длительность",
        },
        { label: "По тренеру", value: 6, index: "employName", title: "Тренер" },
        { label: "По клубу", value: 7, index: "clubName", title: "Клуб" },
        { label: "По залу", value: 8, index: "className", title: "Зал" },
        { label: "По услуге", value: 9, index: "serviceName", title: "Услуга" },
        { label: "По лимиту", value: 10, index: "limit", title: "Лимит" },
        {
            label: "По изображению",
            value: 11,
            index: "imageUrl",
            title: "Изображение",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [scheduleInfo, setScheduleInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [isCopyModal, setIsCopyModal] = useState(false);
    const [addEditPayload, setAddEditPayload] = useState({});
    const [uploading, setUploading] = useState(false);

    // STORE
    const scheduleList = useSelector(
        (state) => state.ScheduleSlice.scheduleList
    );
    const scheduleListLoading = useSelector(
        (state) => state.ScheduleSlice.scheduleListLoading
    );

    const onClickDelete = () => {
        dispatch(
            scheduleAction({ flag: "delete", value: { id: scheduleInfo.id } })
        ).then(() => {
            dispatch(
                scheduleAction({ flag: "get", value: { ...addEditPayload } })
            );
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "date") {
                        formattedItems["DateFrom"] = values[index][0];
                        formattedItems["DateTo"] = values[index][1];
                    } else if (key === "clubName") {
                        formattedItems["ClubId"] = values[index][0];
                    } else if (key === "time") {
                        formattedItems["TimeFrom"] = values[index][0];
                        formattedItems["TimeTo"] = values[index][1];
                    } else if (key === "price") {
                        formattedItems["PriceFrom"] = values[index][0];
                        formattedItems["PriceTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        setAddEditPayload({
            isDeleted: isDeleted,
            count: pagination.pageSize,
            offset: pagination.pageSize * (pagination.current - 1),
            orderBy: sorter?.column?.dataIndex,
            isDesc: sorter.order
                ? sorter.order === "ascend"
                    ? true
                    : false
                : undefined,
            ...payload,
        });
        dispatch(
            scheduleAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    useEffect(() => {
        dispatch(scheduleAction({ flag: "get" }));
    }, []);

    const clickOnAction = (element) => {
        setScheduleInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            scheduleAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            scheduleAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        if (scheduleInfo) {
            dispatch(
                scheduleUserAction({
                    flag: "get",
                    value: { id: scheduleInfo.id },
                })
            );
        }
    }, [scheduleInfo]);
    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(scheduleAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    const formatedRows = scheduleList?.data?.value?.rows.map((element) => {
        return {
            ...element,
            imageUrl: (
                <Image
                    alt="Отсутствует изображение"
                    width={120}
                    src={element?.imageUrl}
                    fallback={
                        fallback || "https://placehold.co/400x400?text=No+Photo"
                    }
                />
            ),
        };
    });

    return (
        <>
            <AddEditScheduleModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                scheduleInfo={scheduleInfo}
                setPage={setPage}
                setPageSize={setPageSize}
                payload={addEditPayload}
            />
            <CopyScheduleModal
                visible={isCopyModal}
                setVisible={setIsCopyModal}
                scheduleInfo={scheduleInfo}
                setPage={setPage}
                setPageSize={setPageSize}
                payload={addEditPayload}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <>
                    <AdminTable
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        onChange={handleTableChange}
                        loading={scheduleListLoading}
                        onClickRowOne={(record) => {
                            setScheduleInfo(record);
                        }}
                        columns={scheduleList}
                        rows={formatedRows}
                        total={scheduleList?.data?.value?.totalCount}
                        title={() => (
                            <TableTitle
                                isDeleted={isDeleted}
                                showDeletedItems={showDeletedItems}
                                onClickOpenModal={() => {
                                    setIsOpenAddEditModal({
                                        open: true,
                                        flag: "add",
                                    });
                                }}
                                mnemoButton={
                                    !mnemo?.children[0]?.children?.find(
                                        (el) => el.mnemo === "insertBtn"
                                    )
                                }
                                mnemoSwitcher={
                                    !mnemo?.children[0]?.children?.find(
                                        (el) => el.mnemo === "isDeletedBtn"
                                    )
                                }
                            />
                        )}
                        items={items}
                        isDeleted={isDeleted}
                        height={250}
                    />
                    {scheduleInfo && (
                        <SecondTable
                            mnemo={mnemo}
                            scheduleInfo={scheduleInfo}
                        />
                    )}
                </>
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={scheduleList}
                    elementsListLoading={scheduleListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    items={items}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Schedule;
